import React from 'react';
import styled from 'styled-components';
import {FormLabel} from '../form-features/FormLabel';
import {FormGroup} from '../form-features/FormGroup';

export const FormDetail = function ({children, label}) {
    return (
        <Wrapper>
            {label && <FormLabel>{label}</FormLabel>}
            <div>{children}</div>
        </Wrapper>
    );
};

const Wrapper = styled(FormGroup)`
    ,
    label {
        font-size: 14px;
        margin: 0;
    }
    display: flex;
    align-items: center;
    gap: 4px;
`;
